<main class="thp-container" *ngIf="posting">
  @switch (true) {
    @case (activePage === InitialInterviewPage.QUESTIONS_PAGE) {
      <app-talent-happy-path-header [headerOverlineText]="'talent-happy-path.initial-interview-questions.header-overline-text' | translate"
                                    [headerText]="posting.jobTitle"></app-talent-happy-path-header>
    }

    @case ([InitialInterviewPage.APPLICATION_SUBMIT_PAGE, InitialInterviewPage.HANG_TIGHT_PAGE,
            InitialInterviewPage.NO_QUESTIONS_PAGE, InitialInterviewPage.WELCOME_BACK_PAGE, InitialInterviewPage.PAY_TRANSPARENCY,
            InitialInterviewPage.VIDEO_INTERVIEW_LANDING, InitialInterviewPage.VIDEO_INTERVIEW].includes(activePage)) {
      <app-talent-happy-path-header [headerText]="posting.jobTitle"></app-talent-happy-path-header>
    }

    @case (activePage === InitialInterviewPage.SPLASH_PAGE) {
      <app-talent-happy-path-header [headerOverlineText]="'talent-happy-path.initial-interview-questions.splash-page.header-overline-text' | translate">
      </app-talent-happy-path-header>
    }
  }

  <div class="thp-container-body">

    @switch (activePage) {
      @case (InitialInterviewPage.SPLASH_PAGE) {
        <app-initial-interview-splash-page (initialInterviewQuestionsEmitter)="provideQuestions($event)">
        </app-initial-interview-splash-page>
      }

      @case (InitialInterviewPage.PAY_TRANSPARENCY) {
        <app-pay-transparency [returningCandidate]="returningCandidate"></app-pay-transparency>
      }

      @case (InitialInterviewPage.APPLICATION_SUBMIT_PAGE) {
        <app-initial-interview-application-submit-page></app-initial-interview-application-submit-page>
      }

      @case (InitialInterviewPage.QUESTIONS_PAGE) {
        @if (initialInterviewQuestions) {
          <app-initial-interview-questions [initialInterviewQuestions]="initialInterviewQuestions"
                                           [questionsLoading]="questionsLoading"
                                           [returningCandidate]="returningCandidate">
          </app-initial-interview-questions>
        }
      }

      @case (InitialInterviewPage.NO_QUESTIONS_PAGE) {
        <app-initial-interview-no-questions-page [standardQuestionIds]="standardQuestionIds"></app-initial-interview-no-questions-page>
      }

      @case (InitialInterviewPage.HANG_TIGHT_PAGE) {
        <app-initial-interview-hang-tight-page></app-initial-interview-hang-tight-page>
      }

      @case (InitialInterviewPage.WELCOME_BACK_PAGE) {
        <app-initial-interview-welcome-back-page (continue)="enterVideoInterviewOr(InitialInterviewPage.SPLASH_PAGE)"></app-initial-interview-welcome-back-page>
      }

      @case (InitialInterviewPage.VIDEO_INTERVIEW_LANDING) {
        <app-video-interview-landing-page></app-video-interview-landing-page>
      }

      @case (InitialInterviewPage.VIDEO_INTERVIEW) {
        <app-video-interview-page></app-video-interview-page>
      }
    }
  </div>
  <app-talent-happy-path-footer class="thp-footer"></app-talent-happy-path-footer>
</main>

